import { t } from 'i18next';
import { useMemo } from 'react';

import {
  CommonFlex,
  CommonGrid,
  CommonText,
} from '../../../styledComponents/common';
import TransactionReportColumn from './transactionReportColumn';

const ZONE_NAMES = ['Mina', 'Arafat', 'Muzdalifah'];

const CampReadinessChart = ({ campReadinessDashboardData = [] }) => {
  const formattedData = useMemo(() => {
    if (!campReadinessDashboardData?.length) return [];

    return campReadinessDashboardData.map(office => ({
      officeName: office.office_name,
      readinessPercentage: office.readiness_percentage,
      zoneId: office.public_zone_id,
      zoneName: office.public_zone_name,
    }));
  }, [campReadinessDashboardData]);

  const zoneGrouped = useMemo(() => {
    const groups = {};

    formattedData.forEach(data => {
      if (!groups[data.zoneName]) {
        groups[data.zoneName] = {
          zoneId: data.zoneId,
          zoneName: data.zoneName,
          offices: [],
        };
      }

      groups[data.zoneName].offices.push({
        officeName: data.officeName,
        readinessPercentage: data.readinessPercentage,
      });
    });

    return Object.values(groups);
  }, [formattedData]);

  if (!campReadinessDashboardData?.length) {
    return (
      <CommonFlex justifyContent="center" margin="30px 0">
        <CommonText>{t('no_data_available')}</CommonText>
      </CommonFlex>
    );
  }

  const existingZones = zoneGrouped.reduce((acc, zone) => {
    acc[zone.zoneName] = zone;
    return acc;
  }, {});

  return (
    <CommonGrid gap="20px" columns="1fr 1fr 1fr">
      {ZONE_NAMES.map((zoneName, index) => {
        if (existingZones[zoneName]) {
          const zone = existingZones[zoneName];
          return (
            <TransactionReportColumn
              key={zone.zoneId || `zone-${index}`}
              title={zone.zoneName}
              data={zone.offices.map(office => ({
                label: office.officeName,
                value: office.readinessPercentage,
              }))}
            />
          );
        }
        return (
          <TransactionReportColumn
            key={`empty-${index}`}
            title={zoneName}
            data={[]}
          />
        );
      })}
    </CommonGrid>
  );
};

export default CampReadinessChart;
